// @flow

import { handleMapRequest } from '../phasedActionHelpers';
import type { Fact } from '../../shapes/types';
import type { LoadAlbumFactsAction } from '../../actions/album';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +entities: Array<Fact>,
  |},
  loading: boolean,
};

const initialState = {
  loading: false,
};

export default function albumFacts(
  state: State = initialState,
  action: LoadAlbumFactsAction
): State {
  if (action.type === 'FETCH_ALBUM_FACTS' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
